import { CLIENTS } from "../../data/site";
import { SectionHead } from "../SectionHead";

const styles = [
  "font-display font-semibold uppercase tracking-[0.12em]",
  "font-body font-medium italic tracking-tight",
  "font-display font-medium tracking-[-0.03em]",
  "font-body font-semibold uppercase tracking-[0.3em] text-[0.7em]",
];

const Word = ({ name, i }) => (
  <li className="flex shrink-0 items-center gap-10 pr-10 sm:gap-16 sm:pr-16">
    <span className={`${styles[i % styles.length]} whitespace-nowrap text-[#6b6b66] transition-colors duration-500 hover:text-[color:var(--ngp-ink)] [&:hover]:drop-shadow-[0_0_0_var(--ngp-teal)]`}>
      {name}
    </span>
    <span className="h-2 w-2 rotate-45 bg-[color:var(--ngp-teal)]" aria-hidden="true" />
  </li>
);

export const Clients = () => (
  <section data-testid="clients-section" className="overflow-hidden border-y border-[color:var(--ngp-line)] bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <SectionHead index="05" eyebrow="Clienti" lines={["Le aziende che", "si affidano a noi."]}
        text="Ci hanno scelto perché il nostro team segue ogni tipo di progetto: stampa digitale, allestimenti, creatività e gadget personalizzati." />
    </div>
    <div className="marquee group relative mt-16 lg:mt-20" data-testid="clients-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent sm:w-40" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent sm:w-40" />
      <ul className="marquee-track flex w-max items-center text-3xl sm:text-5xl lg:text-6xl" aria-label="Elenco clienti">
        {[...CLIENTS, ...CLIENTS].map((c, i) => <Word key={i} name={c} i={i} />)}
      </ul>
    </div>
    <p className="mx-auto mt-10 max-w-[1440px] px-5 text-xs text-[color:var(--ngp-muted)] sm:px-8 lg:px-12">I marchi citati appartengono ai rispettivi proprietari.</p>
  </section>
);
